function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.33325 12.3497C3.33325 16.1054 6.07276 18.8332 9.94124 18.8332C13.8401 18.8332 16.6646 16.1075 16.6666 12.3538C16.6666 10.7966 16.4562 9.98843 15.7177 8.73653C14.8982 7.35231 15.0439 6.37725 15.05 6.34061C15.0844 6.14926 15.0136 5.95384 14.8618 5.83578C14.7121 5.71771 14.5098 5.69328 14.3358 5.77064C14.2913 5.78896 13.2493 6.27954 12.8446 7.71261C12.7455 8.06884 12.6747 8.43322 12.6322 8.79963C12.4825 8.54314 12.3429 8.28869 12.2437 8.06884C11.1451 5.65257 11.6651 2.81493 11.6691 2.78643C11.7055 2.60933 11.6469 2.42612 11.5153 2.30399C11.3838 2.18185 11.1977 2.13707 11.0257 2.18592C10.8922 2.2246 7.75611 3.19559 7.01762 7.24849C6.74853 8.72228 6.91444 10.1615 7.13092 11.1182C6.81125 10.8943 6.52394 10.5788 6.24473 10.1269C5.82794 9.45713 5.51029 8.24798 5.50624 8.2378C5.44757 8.03627 5.28166 7.8836 5.07326 7.85511C4.86487 7.83068 4.66254 7.93449 4.55935 8.1177C4.50877 8.20523 3.33325 10.3548 3.33325 12.3497Z",
  fill: "#777065"
});
function SvgHotDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotDeals);
export default __webpack_public_path__ + "static/media/hot-deals.715b2e0b.svg";
export { ForwardRef as ReactComponent };